import { render, staticRenderFns } from "./KETSpecials.vue?vue&type=template&id=74b22c60&"
import script from "./KETSpecials.vue?vue&type=script&lang=js&"
export * from "./KETSpecials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports